// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import Label from "../../../components/Label";
import { useTranslation } from "react-i18next";
import Image from "../../../components/Image";
import useAuth from "../../../hooks/useAuth";
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const getIconPng = (name) => (
  <Image src={`/static/icons/${name}.png`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon("ic_dashboard"),
  supervisor: getIcon("ic_supervisor"),
  agent: getIcon("ic_agent"),
  customer: getIcon("ic_customer"),
  security_and_limit: getIcon("ic_security_and_limit"),
  user: getIcon("ic_user"),
  ticket: getIconPng("ticket"),
  report: getIcon("ic_report"),
  globe: getIcon("globe-svgrepo-com"),
  cash_f: getIcon("cash-flow"),
  moncash: getIconPng("moncash"),
  topup: getIconPng("topup"),
  depo: getIconPng("depo"),
  send_money: getIconPng("send_money"),
  vendor: getIconPng("vendor"),
  configuration: getIconPng("configuration"),
  refund: getIconPng("refund"),
};

const NavConfig = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: t("sideBar.OVERVIEW"),
      items: [
        {
          title: t("sideBar.OVERVIEW"),
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
        },
        {
          title: t("sideBar.vendor"),
          path: PATH_DASHBOARD.agent.root,
          icon: ICONS.vendor,
          children: [
            { title: t("sideBar.add_vendor"), path: PATH_DASHBOARD.agent.add },
            {
              title: t("sideBar.list_vendor"),
              path: PATH_DASHBOARD.agent.list,
            },
          ],
        },
        {
          title: t("p_sendtopup.sendtopup"),
          path: PATH_DASHBOARD.sendtopup.root,
          icon: ICONS.topup,
        },
        {
          title: t("p_sendtransfer.sendtransfer"),
          path: PATH_DASHBOARD.sendtransfer.root,
          icon: ICONS.send_money,
        },
        {
          title: t("p_ticket.cancelTicket"),
          path: PATH_DASHBOARD.ticket.refund,
          icon: ICONS.refund,
        },
        {
          title: t("p_sendmoncash.sendmoncash"),
          path: PATH_DASHBOARD.sendmoncash.root,
          icon: ICONS.moncash,
        },
        {
          title: t("params.deposit_account"),
          path: PATH_DASHBOARD.user.deposit_account,
          icon: ICONS.depo,
        },
      ],
    },
    {
      subheader: t("sideBar.TRANSACTIONS"),
      items: [
        {
          title: t("params.all_transaction"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.ticket,
          children: [
            // TICKETS
            {
              title: t("sideBar.ticket_sale"),
              path: PATH_DASHBOARD.ticket.sale,
              icon: ICONS.ticket,
            },
            // REPORTS
            {
              title: t("sideBar.report_sale"),
              path: PATH_DASHBOARD.report.sale,
              icon: ICONS.report,
            },
            {
              title: t("params.all_transaction"),
              path: PATH_DASHBOARD.report.transactions,
              icon: ICONS.report,
            },
          ],
        },
      ],
    },
    {
      subheader: t("sideBar.configuration"),
      items: [
        {
          title: t("sideBar.configuration"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.configuration,
          children: [
            {
              title: t("p_usercommission.usercommission"),
              path: PATH_DASHBOARD.configuration.usercommission,
            },
            {
              title: t("sideBar.limit_transaction_generale"),
              path: PATH_DASHBOARD.security_and_limit
                .limit_transaction_generale,
            },
            {
              title: t("sideBar.exchange_rate"),
              path: PATH_DASHBOARD.configuration.exchange_rate,
            },
            {
              title: t("sideBar.feegenerale"),
              path: PATH_DASHBOARD.configuration.fee,
            },
          ],
        },
      ],
    },

    // PARAMETTRE
    // ----------------------------------------------------------------------
    {
      subheader: "Paramettre",
      items: [
        {
          title: t("sideBar.user"),
          path: PATH_DASHBOARD.user.account,
          icon: ICONS.user,
        },
      ],
    },
  ];
  if (!user?.transfer_opt_in) {
    navConfig[0].items = navConfig[0].items.filter(
      (item) =>
        item.path !== PATH_DASHBOARD.sendtransfer.root &&
        item.path !== PATH_DASHBOARD.ticket.refund
    );
  }
  return navConfig;
};

export default NavConfig;
